import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock, Sparkles } from 'lucide-react';
export function PriceOffer() {
  return <section id="offer" className="py-24 px-4 bg-cream-100" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <FadeIn data-id="element-152">
          <div className="bg-white rounded-[2.5rem] p-8 md:p-16 shadow-xl border-2 border-gold-200 relative overflow-hidden" data-id="element-153">
            {/* Decorative background */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-154"></div>

            <div className="relative z-10 text-center" data-id="element-155">
              <Sparkles className="w-12 h-12 text-gold mx-auto mb-6" data-id="element-156" />

              <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-157">
                Recupera la paz de tu hogar hoy mismo.
              </h2>

              <p className="text-xl text-warmBrown-700 mb-10 max-w-2xl mx-auto" data-id="element-158">
                No necesitas terapia costosa ni meses de estudio. Solo necesitas
                las herramientas correctas para los momentos de crisis.
              </p>

              <div className="bg-cream-50 rounded-3xl p-8 mb-10 border border-cream-200 inline-block w-full max-w-md mx-auto" data-id="element-159">
                <p className="text-warmBrown-600 font-bold uppercase tracking-widest text-sm mb-2" data-id="element-160">
                  Inversión Total
                </p>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-161">
                  <span className="text-3xl font-bold text-warmBrown-400 line-through opacity-60" data-id="element-162">
                    $27
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2 mb-3" data-id="element-163">
                  <span className="text-6xl font-bold text-terracotta" data-id="element-164">
                    $6.39
                  </span>
                  <span className="text-xl text-terracotta-600 font-bold mt-4" data-id="element-165">
                    USD
                  </span>
                </div>
                <span className="inline-block bg-sage text-white text-sm font-bold px-4 py-1.5 rounded-full mb-4" data-id="element-166">
                  ¡Ahorra 76% — Oferta por tiempo limitado!
                </span>
                <p className="text-sm text-warmBrown-600" data-id="element-167">
                  Acceso instantáneo al Bundle completo:
                  <br data-id="element-168" />
                  <span className="font-semibold" data-id="element-169">
                    Guía + Checklists + Plan de Emergencia
                  </span>
                </p>
              </div>

              <Button href="https://www.nuvikali.com/cart/44831599362150:1" className="w-full md:w-auto text-xl py-6 px-12 shadow-xl shadow-terracotta/20 mb-6" data-id="element-170">
                ¡SÍ, QUIERO CRIAR CON CALMA!
              </Button>

              <div className="flex items-center justify-center gap-2 text-warmBrown-500 text-sm" data-id="element-171">
                <Lock className="w-4 h-4" data-id="element-172" />
                <p data-id="element-173">
                  Recibe tu acceso seguro de inmediato por correo electrónico.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}